import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTopicTableColumnNames,
  fetchAllTopics,
  addTopics,
  updateTopics,
  deleteTopics,
  activateDeactivateTopics,
  uploadTopicsImageIcon,
  getTopicPrivilege,
  addTopicPrivilege,
  deleteTopicPrivilege,
  fetchGrade,
  fetchExaminationBoard,
} from "./thunk";
import { toast } from "react-toastify";

const topicSlice = createSlice({
  name: "topics",
  initialState: {
    topicsList: [], 
    gradeList: [], 
    examinationBoard: [], 
    topicTableColumnNames: [], 
    topicPrivilege: null, 
    uploadedImageUrl: null,
    loading: false,
    headerload: false,
    imageload: false,
    error: null,
  },
  reducers: {
    clearUploadedTopicImageUrl: (state) => {
      state.uploadedImageUrl = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Topic Table Column Names
      .addCase(fetchTopicTableColumnNames.pending, (state) => {
        state.headerload = true;
        state.error = null;
      })
      .addCase(fetchTopicTableColumnNames.fulfilled, (state, action) => {
        state.headerload = false;
        state.topicTableColumnNames = action.payload;
      })
      .addCase(fetchTopicTableColumnNames.rejected, (state, action) => {
        state.headerload = false;
        state.error = action.payload;
      })

      // Fetch All Topics
      .addCase(fetchAllTopics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTopics.fulfilled, (state, action) => {        
        state.loading = false;
        state.topicsList = action.payload;
      })
      .addCase(fetchAllTopics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Add Topic
      .addCase(addTopics.pending, (state) => {
        state.error = null;
      })
      .addCase(addTopics.fulfilled, (state, action) => {
        state.topicsList.unshift(action.payload[0]); 
      })
      .addCase(addTopics.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Topic
      .addCase(updateTopics.pending, (state) => {
        state.error = null;
      })
      .addCase(updateTopics.fulfilled, (state, action) => {
        const updatedTopic = action.payload[0];
        const index = state.topicsList.findIndex(t => t.ID === updatedTopic.ID);
        if (index !== -1) {
          state.topicsList[index] = updatedTopic;
        }
      })
      .addCase(updateTopics.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Topics
      .addCase(deleteTopics.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteTopics.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.topicsList = state.topicsList.filter((item) => !deletedIds.includes(item.ID));
      })
      .addCase(deleteTopics.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Activate/Deactivate Topic
      .addCase(activateDeactivateTopics.pending, (state) => {
        
        state.error = null;
      })
      .addCase(activateDeactivateTopics.fulfilled, (state, action) => {
        // Assuming action.payload is the updated topic object or an array with it
        const updatedTopic = Array.isArray(action.payload) ? action.payload[0] : action.payload;
        const index = state.topicsList.findIndex(t => t.ID === updatedTopic?.ID);
        
        if (index !== -1) {
          state.topicsList[index] = { ...state.topicsList[index], ...updatedTopic };
        }
      })
      .addCase(activateDeactivateTopics.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Upload Topic Image Icon
      .addCase(uploadTopicsImageIcon.pending, (state) => {
        state.imageload = true;
        state.error = null;
      })
      .addCase(uploadTopicsImageIcon.fulfilled, (state, action) => {
        state.imageload = false;
        state.uploadedImageUrl = action.payload; 
      })
      .addCase(uploadTopicsImageIcon.rejected, (state, action) => {
        state.imageload = false;
        state.error = action.payload;
      })
  },
});

export const { clearUploadedTopicImageUrl } = topicSlice.actions;
export default topicSlice.reducer;
